import BlockCollapse from './block-collapse';

export default {
  tag: 'blockcollapse',
  format: `<BlockCollapse />`,
  sourcePipeline: (source: string) => source,
  componentFn: ({ node, ...props }: any) => {
    return <BlockCollapse {...props} defaultExpend={true} />;
  },
};
